import React, { useEffect, useState } from "react";
import Input from "../../common/Input";
import Button from "../../common/Button";
import Edit from "../../common/icons/Edit";
import { FieldArray, Form, Formik } from "formik";
import { getLookupMargins, saveLookupMargins } from "../../../redux/Thunk/LookupMargin/MarginThunk";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../Loader";
import * as Yup from "yup";


const categorySchema = Yup.number()
.typeError("Must be a number")
.min(0, "Cannot be negative")
.required("Required");

const validationSchema = Yup.object().shape({
    categories: Yup.array().of(
      Yup.object().shape({
        category_a: categorySchema,
        category_b: categorySchema,
        category_c: categorySchema,
        category_d: categorySchema,
        category_e: categorySchema,
        discount: categorySchema,
      })
    )
  });

function Vtable() {
    const [editingField, setEditingField] = useState(null); // Tracks the field being edited
    const [showEditIcon, setShowEditIcon] = useState(false);
    const dispatch = useDispatch();
    const { lookupMargins, isLoading } = useSelector((state) => state.lookup);

    const initialValues = {
        categories: Array.from({ length: 10 }).map((_, index) => {
            const type = "V" + (index + 1);
            const existing = lookupMargins?.data?.find(
                (item) => item.type.toLowerCase() === type.toLowerCase()
            );
            return {
                type,
                ...(existing ? { id: existing?.id } : {}),
                category_a: existing?.category_a ?? 0,
                category_b: existing?.category_b ?? 0,
                category_c: existing?.category_c ?? 0,
                category_d: existing?.category_d ?? 0,
                category_e: existing?.category_e ?? 0,
                discount: existing?.discount ?? 0,
            };
        }),
    };
    const handleFocus = (fieldName) => {
        const inputField = document.querySelector(`[name="${fieldName}"]`);

        if (inputField) {
            inputField.focus();
        }
    };

    const handleEditIconClick = (e, fieldName, index) => {
        e.preventDefault();
        setEditingField(fieldName);
        setTimeout(() => handleFocus(fieldName), 0);
    };

    const handleBlur = (fieldName, setFieldTouched) => {
        if (editingField === fieldName) {
            setEditingField(null);
        }
        setFieldTouched(fieldName, true);
    };

    const handleAddProduct = async (
        values,
    ) => {
       let response = await dispatch(saveLookupMargins(values)).unwrap()
        if(response?.message)
        setShowEditIcon(false)
    };

    const handleOnChange = (e, fieldName, setFieldValue, setFieldTouched) => {
        let value = e.target.value.trim();
        if (!isNaN(value)) {
            value = value.replace(/^0+(?=\d)/, "");
        }
        setFieldValue(fieldName, value);
        setFieldTouched(fieldName, true, false);
    };

    useEffect(() => {
        dispatch(getLookupMargins());
    }, [dispatch]);

    return (
        <section className="bg-gray-100 py-3 px-5 rounded-[20px] overflow-x-auto">
            {isLoading? <Loader loading={isLoading} /> : null}
            <Formik
                enableReinitialize={true}
                initialValues={initialValues}
                onSubmit={handleAddProduct}
                validationSchema={validationSchema}
                validateOnChange={true}
                validateOnBlur={true}
            >
                {({
                    values,
                    setValues,
                    resetForm,
                    handleChange,
                    setFieldValue,
                    touched,
                    errors,
                    setFieldTouched,
                    validateField,
                    setFieldError,
                    validateForm,
                }) => {
                    return (
                        <Form className="dashboard-container">
                            <FieldArray name="categories">
                                {() => (
                                    <>
                                        {values.categories.map(
                                            (item, index) => (
                                                <div
                                                    key={index}
                                                    className="flex gap-x-2 mb-3 [&:nth-last-child(1)]:mb-0">
                                                    <div className="p-[12px] h-[57px] rounded-[16px] border border-black-main flex items-center justify-center w-[80px]">
                                                        <h3 className="font-semibold text-[20px]">
                                                            {item.type}
                                                        </h3>
                                                    </div>
                                                    <div className="w-[calc(16.66%_-_20px)] min-w-[150px]">
                                                        <div className="w-full">
                                                            <Input
                                                                inputBox="mb-0"
                                                                labelClassName="block text-primary-400 text-[13px] leading-[20px]"
                                                                className="border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
                                                                type="text"
                                                                labelName="A*"
                                                                name={`categories[${index}].category_a`}
                                                                value={
                                                                    values
                                                                        .categories[
                                                                        index
                                                                    ].category_a
                                                                }
                                                                onChange={(
                                                                    e
                                                                ) => {
                                                                    handleOnChange(
                                                                        e,
                                                                        `categories[${index}].category_a`,
                                                                        setFieldValue,
                                                                        setFieldTouched
                                                                    );
                                                                }}
                                                                isError={
                                                                    touched
                                                                        ?.categories?.[
                                                                        index
                                                                    ]
                                                                        ?.category_a &&
                                                                    Boolean(
                                                                        errors
                                                                            ?.categories?.[
                                                                            index
                                                                        ]
                                                                            ?.category_a
                                                                    )
                                                                }
                                                                errorMessage={
                                                                    errors
                                                                        ?.categories?.[
                                                                        index
                                                                    ]
                                                                        ?.category_a
                                                                }
                                                                disabled={
                                                                    editingField !==
                                                                    `categories[${index}].category_a`
                                                                }
                                                                showEditIcon={
                                                                    showEditIcon
                                                                }
                                                                onBlur={() => {
                                                                    handleBlur(
                                                                        `categories[${index}].category_a`,
                                                                        setFieldTouched
                                                                    );
                                                                }}
                                                                onEditClick={(
                                                                    e
                                                                ) =>
                                                                    handleEditIconClick(
                                                                        e,
                                                                        `categories[${index}].category_a`
                                                                    )
                                                                }
                                                                padding="none"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="w-[calc(16.66%_-_20px)] min-w-[150px]">
                                                        <div className="w-full">
                                                            <Input
                                                                inputBox="mb-0"
                                                                labelClassName="block text-primary-400 text-[13px] leading-[20px]"
                                                                className="border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
                                                                type="text"
                                                                labelName="B*"
                                                                name={`categories[${index}].category_b`}
                                                                value={
                                                                    values
                                                                        .categories[
                                                                        index
                                                                    ].category_b
                                                                }
                                                                onChange={(
                                                                    e
                                                                ) => {
                                                                    handleOnChange(
                                                                        e,
                                                                        `categories[${index}].category_b`,
                                                                        setFieldValue,
                                                                        setFieldTouched
                                                                    );
                                                                }}
                                                                isError={
                                                                    touched
                                                                        ?.categories?.[
                                                                        index
                                                                    ]
                                                                        ?.category_b &&
                                                                    Boolean(
                                                                        errors
                                                                            ?.categories?.[
                                                                            index
                                                                        ]
                                                                            ?.category_b
                                                                    )
                                                                }
                                                                errorMessage={
                                                                    errors
                                                                        ?.categories?.[
                                                                        index
                                                                    ]
                                                                        ?.category_b
                                                                }
                                                                disabled={
                                                                    editingField !==
                                                                    `categories[${index}].category_b`
                                                                }
                                                                showEditIcon={
                                                                    showEditIcon
                                                                }
                                                                onBlur={() => {
                                                                    handleBlur(
                                                                        `categories[${index}].category_b`,
                                                                        setFieldTouched
                                                                    );
                                                                }}
                                                                onEditClick={(
                                                                    e
                                                                ) =>
                                                                    handleEditIconClick(
                                                                        e,
                                                                        `categories[${index}].category_b`
                                                                    )
                                                                }
                                                                padding="none"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="w-[calc(16.66%_-_20px)] min-w-[150px]">
                                                        <div className="w-full">
                                                            <Input
                                                                inputBox="mb-0"
                                                                labelClassName="block text-primary-400 text-[13px] leading-[20px]"
                                                                className="border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
                                                                type="text"
                                                                labelName="C*"
                                                                name={`categories[${index}].category_c`}
                                                                value={
                                                                    values
                                                                        .categories[
                                                                        index
                                                                    ].category_c
                                                                }
                                                                onChange={(
                                                                    e
                                                                ) => {
                                                                    handleOnChange(
                                                                        e,
                                                                        `categories[${index}].category_c`,
                                                                        setFieldValue,
                                                                        setFieldTouched
                                                                    );
                                                                }}
                                                                isError={
                                                                    touched
                                                                        ?.categories?.[
                                                                        index
                                                                    ]
                                                                        ?.category_c &&
                                                                    Boolean(
                                                                        errors
                                                                            ?.categories?.[
                                                                            index
                                                                        ]
                                                                            ?.category_c
                                                                    )
                                                                }
                                                                errorMessage={
                                                                    errors
                                                                        ?.categories?.[
                                                                        index
                                                                    ]
                                                                        ?.category_c
                                                                }
                                                                disabled={
                                                                    editingField !==
                                                                    `categories[${index}].category_c`
                                                                }
                                                                showEditIcon={
                                                                    showEditIcon
                                                                }
                                                                onBlur={() => {
                                                                    handleBlur(
                                                                        `categories[${index}].category_c`,
                                                                        setFieldTouched
                                                                    );
                                                                }}
                                                                onEditClick={(
                                                                    e
                                                                ) =>
                                                                    handleEditIconClick(
                                                                        e,
                                                                        `categories[${index}].category_c`
                                                                    )
                                                                }
                                                                padding="none"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="w-[calc(16.66%_-_20px)] min-w-[150px]">
                                                        <div className="w-full">
                                                            <Input
                                                                inputBox="mb-0"
                                                                labelClassName="block text-primary-400 text-[13px] leading-[20px]"
                                                                className="border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
                                                                type="text"
                                                                labelName="D*"
                                                                name={`categories[${index}].category_d`}
                                                                value={
                                                                    values
                                                                        .categories[
                                                                        index
                                                                    ].category_d
                                                                }
                                                                onChange={(
                                                                    e
                                                                ) => {
                                                                    handleOnChange(
                                                                        e,
                                                                        `categories[${index}].category_d`,
                                                                        setFieldValue,
                                                                        setFieldTouched
                                                                    );
                                                                }}
                                                                isError={
                                                                    touched
                                                                        ?.categories?.[
                                                                        index
                                                                    ]
                                                                        ?.category_d &&
                                                                    Boolean(
                                                                        errors
                                                                            ?.categories?.[
                                                                            index
                                                                        ]
                                                                            ?.category_d
                                                                    )
                                                                }
                                                                errorMessage={
                                                                    errors
                                                                        ?.categories?.[
                                                                        index
                                                                    ]
                                                                        ?.category_d
                                                                }
                                                                disabled={
                                                                    editingField !==
                                                                    `categories[${index}].category_d`
                                                                }
                                                                showEditIcon={
                                                                    showEditIcon
                                                                }
                                                                onBlur={() => {
                                                                    handleBlur(
                                                                        `categories[${index}].category_d`,
                                                                        setFieldTouched
                                                                    );
                                                                }}
                                                                onEditClick={(
                                                                    e
                                                                ) =>
                                                                    handleEditIconClick(
                                                                        e,
                                                                        `categories[${index}].category_d`
                                                                    )
                                                                }
                                                                padding="none"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="w-[calc(16.66%_-_20px)] min-w-[150px]">
                                                        <div className="w-full">
                                                            <Input
                                                                inputBox="mb-0"
                                                                labelClassName="block text-primary-400 text-[13px] leading-[20px]"
                                                                className="border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
                                                                type="text"
                                                                labelName="E*"
                                                                name={`categories[${index}].category_e`}
                                                                value={
                                                                    values
                                                                        .categories[
                                                                        index
                                                                    ].category_e
                                                                }
                                                                onChange={(
                                                                    e
                                                                ) => {
                                                                    handleOnChange(
                                                                        e,
                                                                        `categories[${index}].category_e`,
                                                                        setFieldValue,
                                                                        setFieldTouched
                                                                    );
                                                                }}
                                                                isError={
                                                                    touched
                                                                        ?.categories?.[
                                                                        index
                                                                    ]
                                                                        ?.category_e &&
                                                                    Boolean(
                                                                        errors
                                                                            ?.categories?.[
                                                                            index
                                                                        ]
                                                                            ?.category_e
                                                                    )
                                                                }
                                                                errorMessage={
                                                                    errors
                                                                        ?.categories?.[
                                                                        index
                                                                    ]
                                                                        ?.category_e
                                                                }
                                                                disabled={
                                                                    editingField !==
                                                                    `categories[${index}].category_e`
                                                                }
                                                                showEditIcon={
                                                                    showEditIcon
                                                                }
                                                                onBlur={() => {
                                                                    handleBlur(
                                                                        `categories[${index}].category_e`,
                                                                        setFieldTouched
                                                                    );
                                                                }}
                                                                onEditClick={(
                                                                    e
                                                                ) =>
                                                                    handleEditIconClick(
                                                                        e,
                                                                        `categories[${index}].category_e`
                                                                    )
                                                                }
                                                                padding="none"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="w-[calc(16.66%_-_20px)] min-w-[150px]">
                                                        <div className="w-full">
                                                            <Input
                                                                inputBox="mb-0"
                                                                labelClassName="block text-primary-400 text-[13px] leading-[20px]"
                                                                className="border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
                                                                type="text"
                                                                labelName="Dicount*"
                                                                name={`categories[${index}].discount`}
                                                                value={
                                                                    values
                                                                        .categories[
                                                                        index
                                                                    ].discount
                                                                }
                                                                onChange={(
                                                                    e
                                                                ) => {
                                                                    handleOnChange(
                                                                        e,
                                                                        `categories[${index}].discount`,
                                                                        setFieldValue,
                                                                        setFieldTouched
                                                                    );
                                                                }}
                                                                isError={
                                                                    touched
                                                                        ?.categories?.[
                                                                        index
                                                                    ]
                                                                        ?.discount &&
                                                                    Boolean(
                                                                        errors
                                                                            ?.categories?.[
                                                                            index
                                                                        ]
                                                                            ?.discount
                                                                    )
                                                                }
                                                                errorMessage={
                                                                    errors
                                                                        ?.categories?.[
                                                                        index
                                                                    ]?.discount
                                                                }
                                                                disabled={
                                                                    editingField !==
                                                                    `categories[${index}].discount`
                                                                }
                                                                showEditIcon={
                                                                    showEditIcon
                                                                }
                                                                onBlur={() => {
                                                                    handleBlur(
                                                                        `categories[${index}].discount`,
                                                                        setFieldTouched
                                                                    );
                                                                }}
                                                                onEditClick={(
                                                                    e
                                                                ) =>
                                                                    handleEditIconClick(
                                                                        e,
                                                                        `categories[${index}].discount`
                                                                    )
                                                                }
                                                                padding="none"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        )}
                                    </>
                                )}
                            </FieldArray>
                            <div className="pt-3 flex items-center justify-start gap-3">
                                {showEditIcon ? (
                                    <>
                                        <Button
                                            className="flex text-[13px] whitespace-nowrap items-center justify-center gap-2 text-secondry-600 border h-[36px] py-[5px] px-[15px] rounded-full shadow-none outline-none bg-primary-50 border-primary-600"
                                            type="button"
                                            onClick={() => {
                                                resetForm({
                                                    values: initialValues,
                                                  });
                                                setShowEditIcon(false);
                                            }}>
                                            Cancel
                                        </Button>
                                        <Button
                                            className="flex text-[13px] whitespace-nowrap items-center justify-center gap-2 text-secondry-600 border h-[36px] py-[5px] px-[15px] rounded-full shadow-none outline-none bg-primary-50 border-primary-600"
                                            type="submit">
                                            save
                                        </Button>
                                    </>
                                ) : (
                                    <Button
                                        className="flex text-[13px] whitespace-nowrap items-center justify-center gap-2 text-secondry-600 border h-[36px] py-[5px] px-[15px] rounded-full shadow-none outline-none bg-primary-50 border-primary-600"
                                        type="button"
                                        onClick={() => {
                                            setShowEditIcon(true);
                                        }}>
                                        <Edit fill="#513e3e" />
                                        Edit
                                    </Button>
                                )}
                            </div>
                        </Form>
                    );
                }}
            </Formik>
        </section>
    );
}

export default Vtable;
